import { useQuery } from '@apollo/client';
import { transformErrors } from '@core/adapters/errors';
import type { GetCustomLabelsQuery } from '@core/graphql/types';
import { GET_CUSTOM_LABELS } from '@moderation/graphql';
import { useMemo } from 'react';

/**
 * Hook to fetch custom labels for a community
 * @param communityId The ID of the community
 * @returns Custom labels data, loading state, errors, and refetch function
 */
export function useCustomLabels(communityId: string) {
  const { data, loading, error, refetch } = useQuery<GetCustomLabelsQuery>(GET_CUSTOM_LABELS, {
    variables: { communityId },
    fetchPolicy: 'cache-first',
    errorPolicy: 'all',
    skip: !communityId,
  });

  const labels = useMemo(() => data?.customLabels?.labels || [], [data]);

  const errors = useMemo(() => {
    if (!error) return undefined;

    return transformErrors(error);
  }, [error]);

  return {
    labels,
    loading,
    errors,
    refetch,
  };
}
